import { api } from '../../api';
import { useLanguage } from '../../shell/language-context';
import { useResource } from '../../shell/use-resource';
import { ReelRail } from '../reels/reel-rail';
import { MARQUEE_MIN_REELS, ReelsMarquee } from './reels-marquee';
import type { ReelCard } from '../reels/reel-viewer';

// "Reels." (design C1, FR-C29): a rail right under Today's offers with the newest
// approved reels across live listings (GET /v1/reels, API-243). Same rhythm as the
// other home sections; every tile opens the fullscreen viewer. Hidden until there is
// at least one reel, so an empty platform shows no empty band. With enough reels the
// rail drifts left to right on its own (reels-marquee.tsx).
export function ReelsRailSection() {
  const { t, lang } = useLanguage();
  const reels = useResource<{ items: ReelCard[] }>((signal) => api.GET('/reels', { signal, lang }), [lang]);
  const items = reels.data?.items ?? [];
  if (!items.length) return null;
  return (
    <section className="hm-reels" data-reveal="out" aria-labelledby="hm-reels-h">
      <div className="hm-wrap">
        <div className="hm-head hm-head--mb">
          <div>
            <h2 className="hm-h2" id="hm-reels-h">
              {t('reels.title')}
            </h2>
            <p className="hm-sub">{t('reels.sub')}</p>
          </div>
        </div>
        {items.length >= MARQUEE_MIN_REELS ? <ReelsMarquee reels={items} /> : <ReelRail reels={items} />}
      </div>
    </section>
  );
}
